import { ConnectionTypes } from "./ConnectionTypeSection";

export const ACTION_MODAL_DISPLAY_CHANGED = "ACTION_MODAL_DISPLAY_CHANGED";
export const ACTION_HOSTNAME_CHANGED = "ACTION_HOSTNAME_CHANGED";
export const ACTION_HEALTHMONITORINTERVAL_CHANGED = "ACTION_HEALTHMONITORINTERVAL_CHANGED";
export const ACTION_MSB_CHANGED = "ACTION_MSB_CHANGED";
export const ACTION_IP_CHANGED = "ACTION_IP_CHANGED";
export const ACTION_PORT_CHANGED = "ACTION_PORT_CHANGED";
export const ACTION_DEVICE_TYPE_CHANGED = "ACTION_DEVICE_TYPE_CHANGED";
export const ACTION_API_URL_CHANGED = "ACTION_API_URL_CHANGED";
export const ACTION_API_MONITOR_URI_CHANGED = "ACTION_API_MONITOR_URI_CHANGED";
export const ACTION_API_KEY_CHANGED = "ACTION_API_KEY_CHANGED";
export const ACTION_API_USERNAME_CHANGED = "ACTION_API_USERNAME_CHANGED";
export const ACTION_API_PASSWORD_CHANGED = "ACTION_API_PASSWORD_CHANGED";
export const ACTION_GROUPS_LOADED = "ACTION_GROUPS_LOADED";
export const ACTION_GROUP_CHANGED = "ACTION_GROUPS_LOADED";
export const ACTION_CRITICALITY_CHANGED = "ACTION_CRITICALITY_CHANGED";
export const ACTION_CONNECTION_TYPE_CHANGED = "ACTION_CONNECTION_TYPE_CHANGED";
export const ACTION_FIELDSET_CLEANED = "ACTION_FIELDSET_CLEANED";
export const ACTION_SSH_PASSWORLDESS_KEY_CHANGED = "ACTION_SSH_PASSWORLDESS_KEY_CHANGED";
export const ACTION_SSH_USERNAME_CHANGED = "ACTION_SSH_USERNAME_CHANGED";
export const ACTION_WINRM_USERNAME_CHANGED = "ACTION_WINRM_USERNAME_CHANGED";
export const ACTION_SSH_PASSWORD_CHANGED = "ACTION_SSH_PASSWORD_CHANGED";
export const ACTION_WINRM_PASSWORD_CHANGED = "ACTION_WINRM_PASSWORD_CHANGED";
export const ACTION_TAGS_LOADED = "ACTION_TAGS_LOADED";
export const ACTION_SELECTED_TAGS_CHANGED = "ACTION_SELECTED_TAGS_CHANGED";
export const ACTION_STEP_CHANGED = "ACTION_STEP_CHANGED";
export const ACTION_CONNECTION_CHANGED = "ACTION_CONNECTION_CHANGED";
export const ACTION_STATE_CLEANED = "ACTION_STATE_CLEANED";
export const ACTION_MSB_NAME_CHANGED = "ACTION_MSB_NAME_CHANGED";
export const ACTION_ASSIGN_COLLECTED_CONFIG_TO_MSB_CHANGED = "ACTION_ASSIGN_COLLECTED_CONFIG_TO_MSB_CHANGED";
export const ACTION_ENABLE_ALERTING_CHANGED = "ACTION_ENABLE_ALERTING_CHANGED";
export const ACTION_ENABLE_SYSLOG_CONFIG_CHANGED = "ACTION_ENABLE_SYSLOG_CONFIG_CHANGED";
export const ACTION_ENABLE_EMAIL_NOTIFICATION_CHANGED = "ACTION_ENABLE_EMAIL_NOTIFICATION_CHANGED";
export const ACTION_ENABLE_SNMP_NOTIFICATION_CHANGED = "ACTION_ENABLE_SNMP_NOTIFICATION_CHANGED";
export const ACTION_ENABLE_SYSLOG_PROCESSING_CHANGED = "ACTION_ENABLE_SYSLOG_PROCESSING_CHANGED";
export const ACTION_EVENTS_CHANGED = "ACTION_EVENTS_CHANGED";
export const ACTION_SELECTED_EVENTS_CHANGED = "ACTION_SELECTED_EVENTS_CHANGED";
export const ACTION_RULE_CATEGORIES_CHANGED = "ACTION_RULE_CATEGORIES_CHANGED";
export const ACTION_SELECTED_DEVICE_CHANGED = "ACTION_RULE_CATEGORIES_CHANGED";
export const ACTION_MSB_LIST_CHANGED = "ACTION_MSB_LIST_CHANGED";
export const ACTION_ENABLE_PASSWORD_CHANGED = "ACTION_ENABLE_PASSWORD_CHANGED";
export const ACTION_ENABLE_PASSWORD_TEXT_CHANGED = "ACTION_ENABLE_PASSWORD_TEXT_CHANGED";
export const ACTION_POWERCLI_USERNAME_CHANGED = "ACTION_POWERCLI_USERNAME_CHANGED";
export const ACTION_POWERCLI_PASSWORD_CHANGED = "ACTION_POWERCLI_PASSWORD_CHANGED";
export const ACTION_ENABLE_SYSTEM_REMEDIATION_CHANGED = "ACTION_ENABLE_SYSTEM_REMEDIATION_CHANGED";
export const ACTION_DOMAINS_LOADED = "ACTION_DOMAINS_LOADED";
export const ACTION_DOMAIN_CHANGED = "ACTION_DOMAIN_CHANGED";
export const ACTION_DOMAIN_SET_CHANGED = "ACTION_DOMAIN_SET_CHANGED";
export const ACTION_CENTRAL_CREDENTIALS_LOADED = "ACTION_CENTRAL_CREDENTIALS_LOADED";
export const ACTION_CENTRAL_CREDENTIAL_CHANGED = "ACTION_CENTRAL_CREDENTIAL_CHANGED";
export const ACTION_WINRM_HTTPS_CHANGED = "ACTION_WINRM_HTTPS_CHANGED";
export const ACTION_HTTPS_CERTIFICATE_CHANGED = "ACTION_HTTPS_CERTIFICATE_CHANGED";
export const ACTION_MS_TENANT_ID_CHANGED = "ACTION_MS_TENANT_ID_CHANGED";
export const ACTION_MS_CLIENT_ID_CHANGED = "ACTION_MS_CLIENT_ID_CHANGED";
export const ACTION_MS_SUBJECT_CHANGED = "ACTION_MS_SUBJECT_CHANGED";


const initState = {
    step: 0,
    connectionType: ConnectionTypes.SSH,
    showModal: false,
    deviceTypes: [],
    groups: [],
    tags: [],
    selectedTags: [],
    selectedEvents: [],
    healthMonitorInterval: "5",
    msbList: [],
    domains: [],
    centralCredentials: []
};

export function AddDeviceModalReducer(state = initState, action) {

    switch (action.type) {
        case ACTION_STATE_CLEANED:
            return initState;
        case ACTION_MODAL_DISPLAY_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_HOSTNAME_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_HEALTHMONITORINTERVAL_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_IP_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_DEVICE_TYPE_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_API_URL_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_API_MONITOR_URI_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_API_KEY_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_GROUPS_LOADED:
            return { ...state, ...action.payload }
        case ACTION_GROUP_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_API_USERNAME_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_API_PASSWORD_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_CRITICALITY_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_CONNECTION_TYPE_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_FIELDSET_CLEANED:
            return { ...state, ...action.payload }
        case ACTION_SSH_PASSWORLDESS_KEY_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_SSH_USERNAME_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_SSH_PASSWORD_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_WINRM_PASSWORD_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_TAGS_LOADED:
            return { ...state, ...action.payload }
        case ACTION_SELECTED_TAGS_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_STEP_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_CONNECTION_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MSB_NAME_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ASSIGN_COLLECTED_CONFIG_TO_MSB_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ENABLE_ALERTING_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ENABLE_SYSLOG_CONFIG_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ENABLE_EMAIL_NOTIFICATION_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ENABLE_SNMP_NOTIFICATION_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_ENABLE_SYSLOG_PROCESSING_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_EVENTS_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_SELECTED_EVENTS_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_RULE_CATEGORIES_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_SELECTED_DEVICE_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MSB_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MSB_LIST_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_PORT_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_WINRM_USERNAME_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_ENABLE_PASSWORD_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_ENABLE_PASSWORD_TEXT_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_POWERCLI_USERNAME_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_POWERCLI_PASSWORD_CHANGED:
            return { ...state, ...action.payload };
        case ACTION_ENABLE_SYSTEM_REMEDIATION_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_DOMAINS_LOADED:
            return { ...state, ...action.payload }
        case ACTION_DOMAIN_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_DOMAIN_SET_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_CENTRAL_CREDENTIALS_LOADED:
            return { ...state, ...action.payload }
        case ACTION_CENTRAL_CREDENTIAL_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_WINRM_HTTPS_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_HTTPS_CERTIFICATE_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MS_TENANT_ID_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MS_CLIENT_ID_CHANGED:
            return { ...state, ...action.payload }
        case ACTION_MS_SUBJECT_CHANGED:
            return { ...state, ...action.payload }
        default:
            return state;
    }
}
